import axios from 'axios'
import moment from 'moment'
import config from '../variables/config'

export const LOGIN = 'admin/LOGIN'
export const LOGOUT = 'admin/LOGOUT'
export const LOGIN_REQUESTED = 'admin/LOGIN_REQUESTED'
export const LOGOUT_REQUESTED = 'admin/LOGOUT_REQUESTED'
export const REQUEST_FAILED = 'admin/REQUEST_FAILED'
export const REQUEST_STOP = 'admin/REQUEST_STOP'

const setInitial = () => {
  var userData = window.localStorage.getItem('userData')
  var defaults = {
    user: {},
    token: '',
    tokenObj: {},
    userLoggedIn: false,
    requestLoading: false,
    requestFailed: false
  }

  try {
    userData = JSON.parse(userData)
  } catch (error) {
    userData = {}
  }
  if (userData && userData != null && userData.tokenObj) {
    var expireDate = moment(userData.tokenObj.created)
    expireDate.add(userData.tokenObj.ttl, 'seconds')
    if (expireDate.isBefore(moment())) {
      return defaults
    }

    defaults.userLoggedIn = true
    defaults.user = userData.user
    defaults.token = userData.token
    defaults.tokenObj = userData.tokenObj

    return defaults
  } else {
    return defaults
  }
}

const initialState = setInitial()

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: action.user,
        token: action.token,
        tokenObj: action.tokenObj,
        userLoggedIn: true,
        requestLoading: false
      }

    case LOGIN_REQUESTED:
      return {
        ...state,
        requestLoading: true
      }

    case LOGOUT:
      return {
        ...state,
        user: {},
        token: {},
        tokenObj: {},
        userLoggedIn: false,
        requestLoading: false
      }

    case LOGOUT_REQUESTED:
      return {
        ...state,
        requestLoading: true
      }

    case REQUEST_FAILED:
      return {
        ...state,
        requestFailed: true,
        requestLoading: false
      }

    case REQUEST_STOP:
      return {
        ...state,
        requestFailed: false
      }

    default:
      return state
  }
}

export const logout = state => {
  return async dispatch => {
    window.localStorage.setItem('userData', JSON.stringify({}))
    dispatch({
      type: LOGOUT
    })
  }
}

export const login = state => {
  return async dispatch => {
    dispatch({
      type: LOGIN_REQUESTED
    })

    try {
      var response = await axios.post(
        config.serverURL + '/AdminUsers/login?include=USER',
        state
      )
      if (response.status === 200) {
        dispatch({
          type: LOGIN,
          token: response.data.id,
          tokenObj: response.data,
          user: response.data.user
        })

        window.localStorage.setItem(
          'userData',
          JSON.stringify({
            token: response.data.id,
            tokenObj: response.data,
            user: response.data.user,
            role: 'admin'
          })
        )
      } else {
        console.log('login: not 200 response', { response })

        dispatch({
          type: REQUEST_FAILED
        })
      }
    } catch (error) {
      console.log('login: caught error', { error })

      // dispatch({
      //   type: REQUEST_FAILED
      // })
      staffLogin(state)(dispatch)
    }
  }
}

const staffLogin = state => {
  return async dispatch => {
    dispatch({
      type: LOGIN_REQUESTED
    })

    try {
      var response = await axios.post(
        config.serverURL + '/StaffUsers/login?include=USER',
        state
      )
      if (response.status === 200) {
        dispatch({
          type: LOGIN,
          token: response.data.id,
          tokenObj: response.data,
          user: response.data.user
        })

        window.localStorage.setItem(
          'userData',
          JSON.stringify({
            token: response.data.id,
            tokenObj: response.data,
            user: response.data.user,
            role: 'staff',
            branch: response.data.user.realm
          })
        )
      } else {
        dispatch({
          type: REQUEST_FAILED
        })
      }
    } catch (error) {
      dispatch({
        type: REQUEST_FAILED
      })
    }
  }
}

export const sendRequest = (request, data) => {
  return (dispatch, getState) => {
    const tokenObj = getState().admin.tokenObj
    var expireDate = moment(tokenObj.created)
    expireDate.add(tokenObj.ttl, 'seconds')

    if (expireDate.isBefore(moment())) {
      dispatch({
        type: LOGOUT
      })
    } else {
      dispatch(request(data))
    }
  }
}
